import { render, staticRenderFns } from "./ImprimirRelatorio.vue?vue&type=template&id=1fb1ef07&scoped=true&"
import script from "./ImprimirRelatorio.vue?vue&type=script&lang=js&"
export * from "./ImprimirRelatorio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb1ef07",
  null
  
)

export default component.exports